import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { take } from 'rxjs/operators';
import { ApiError, MessageService } from '../../../../core';
import { AreaSearch } from '../../area-search';
import { AreaSearchOrderBy } from '../../area-search-orderby';
import { AreaFilter } from '../../filter';
import { AreaSearchHttpService } from '../../services';
import { areaSituacaoAtiva } from '../../situacao';


@Component({
    selector: 'sgt-area-select',
    templateUrl: './area-select.component.html',
    styleUrls: ['./area-select.component.less']
})
export class AreaSelectComponent implements OnInit {
    areas: AreaSearch[];

    /** Área selecionada */
    @Input() area: AreaSearch;
    /** Áre alterada */
    @Output() areaChange = new EventEmitter<AreaSearch>();
    /** ID da área */
    @Input() idArea: number;
    /** Ao alterar o ID da área */
    @Output() idAreaChange = new EventEmitter<number>();

    /** Se deve exibir o title do select */
    @Input() isShowTitle = false;
    /** Se deve exibir a opção de selecionar a opção nula */
    @Input() isShowNull = true;
    /** Label para a opção de selecionar a opção nula */
    @Input() nullLabel = 'Nenhuma área'
    /** Label para a opção nula quando estiver selecionada */
    @Input() nullLabelSelected = 'Nenhuma área'
    /** Se deve desabilitar o input */
    @Input() disabled: boolean;
    /** Se deve filtrar somente as áreas ativas */
    @Input() somenteAtivas = false;

    /** Após iniciar o select */
    @Output() afterInitialized = new EventEmitter<void>();

    /** Após selecionar a área */
    @Output() afterSelect = new EventEmitter<void>();


    constructor(private messageService: MessageService,
                private areaSearchHttpService: AreaSearchHttpService) { }

    async ngOnInit(): Promise<void> {
        await this.search();
        setTimeout(() => this.afterInitialized.emit(), 0);
    }

    /** Pesquisa as áreas */
    private search(): Promise<void> {
        return new Promise<void>((resolve) => {
            this.areas = [];


            const filter = new AreaFilter();
            // Somente ativas
            if (this.somenteAtivas) {
                filter.situacoes = [areaSituacaoAtiva.id];
            }

            this.areaSearchHttpService.search(filter, AreaSearchOrderBy.Nome, 'asc', null, null)
                .pipe(
                    take(1)
                )
                .subscribe(
                    areas => {
                        if (areas) {
                            this.areas = areas;

                            if (this.areas?.length > 0) {
                                if (this.idArea) { // Se for informado um ID de área, obtemos e selecionamos ela
                                    const area = this.areas.find(areaFilter => areaFilter.id === this.idArea);
                                    this.select(area);
                                } else if (!this.isShowNull) {  // Se não, selecionamos a primeira área
                                    this.select(this.areas[0]);
                                }
                            }
                        }
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, error.cause, error);
                    },
                    () => resolve()
                );
        });
    }

    /** Ao selecionar a área */
    select(area: AreaSearch) {
        this.idArea = area ? area.id : null;
        this.idAreaChange.emit(this.idArea);
        this.area = area;
        this.areaChange.emit(this.area);

        this.afterSelect.emit();
    }
}
